import type { ApiConfig } from '../../types'

export const fillHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 2000,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'fill-history',
} as const satisfies ApiConfig
